import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  patientDetail: [],
  errorStatus: null,
};
const getters = {
  getApiLoad_64: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  SET_Status(state, status) {
    state.successFlag = status;
  },
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_PatientDetail(state, patientDetails) {
    state.patientDetail = patientDetails;
  },
};
const actions = {
  errorPatientDetail({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getPatientDetailByFollowup({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/PatientDetails/FollowUp?patientId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PatientDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientDetail', error);
      });
  },
  addPatientDetail({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/PatientDetails', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPatientDetail', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
